import Vue from 'vue'
import Vuex from 'vuex'
//https://github.com/robinvdvleuten/vuex-persistedstate

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
  }
})
